import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClickJump = (item: string) => {
    if (item === "Home") {
      navigate("/");
    } else {
      navigate(`/${item.toLocaleLowerCase()}`);
    }
  };

  return (
    <>
      <div className="w-full flex justify-center pt-12 pb-8 bg-[#f6f7f8]">
        <div className="w-full max-w-[1116px] px-8 flex flex-col items-center">
          <div
            className={`w-full ${
              windowWidth > 800
                ? "flex justify-between"
                : "flex flex-col gap-y-4"
            }`}
          >
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[24%]" : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs" : "text-sm"
                  }`}
                >
                  ABOUT ME
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <p className="text-sm">{process.env.REACT_APP_DESCRIPTION}</p>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[15%]" : "w-full"
              }`}
            >
              <div className="mb-8 border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs" : "text-sm"
                  }`}
                >
                  QUICK LINK
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <ul className="flex flex-col text-xs font-medium text-gray-600">
                {["Home", "Travel", "Guides", "Food", "Hotels"].map(
                  (item, index) => (
                    <li
                      key={index}
                      className={`flex border-b-[1px] border-dotted border-[#d1d2d3] py-2.5 cursor-pointer last-of-type:border-b-0
                           ${
                             location.pathname === item.toLocaleLowerCase()
                               ? "text-[#5b68d3]"
                               : "hover:text-[#5b68d3]"
                           }`}
                      onClick={() => handleClickJump(item)}
                    >
                      <span>{item}</span>
                    </li>
                  )
                )}
              </ul>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[22%] " : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs " : "text-sm"
                  }`}
                >
                  TAGCLOUD
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <ul className="flex flex-wrap text-xs font-medium text-gray-600">
                {[
                  "Cultural Stays",
                  "Living guide",
                  "Festival foods",
                  "Seasonal view",
                  "Tropical getaways",
                  // "Tea mastery",
                  // "Puppet theatre",
                ].map((item, index) => (
                  <li
                    key={index}
                    className="flex border-[1px] px-5 py-2 bg-[#f0f1f3] rounded-full mr-2 mb-3 hover:text-[#5b68d3]"
                  >
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div
              className={`flex flex-col ${
                windowWidth > 800 ? "w-[31%]" : "w-full"
              }`}
            >
              <div className="mb-8  border-b-[1px]">
                <h5
                  className={`font-semibold pt-2 pb-2 tracking-widest ${
                    windowWidth > 800 ? "text-xs " : "text-sm"
                  }`}
                >
                  NEWSLETTER
                </h5>
                <span className="block w-14 h-[3px] bg-black"></span>
              </div>
              <p className="text-sm line-clamp-3">
                Subscribe to our newsletter and get our newest updates right on
                your inbox.
              </p>
              <form className="mt-8 flex flex-col">
                <div className="flex items-center mb-5">
                  <input
                    className="w-[62%] py-3 px-4 placeholder:text-[#909090] border-[1px] border-r-0 border-[#dddddd] rounded-full rounded-r-none focus:outline-none"
                    type="text"
                    placeholder="Enter your email"
                  />
                  <button className="w-[38%] py-3 border-[1px] border-l-0 border-[#dddddd] rounded-full rounded-l-none bg-[#5b68d3] hover:bg-[#3a47ab] text-white text-base font-bold">
                    Subscribe
                  </button>
                </div>
                <label>
                  <input type="checkbox" />
                  <span className="text-sm ml-2">
                    I agree to the{" "}
                    <b className="text-[#646f80] cursor-pointer font-medium hover:text-[#5b68d3]">
                      terms & conditions
                    </b>
                  </span>
                </label>
              </form>
            </div>
          </div>
          <div
            className={`w-full flex pt-8 mt-8 border-t-[1px] text-xs text-[#5c687a]${
              windowWidth > 950
                ? " justify-between space-x-2"
                : " flex-col space-y-2"
            }`}
          >
            <span>
              © 2020, Stories - Personal Blog HTML Template ⇒ © 2025 Puffygame.
              Everything you need to know about Asia.
            </span>
            <span>
              All Rights Reserved. |{" "}
              <b
                className="text-blue-600 cursor-pointer hover:underline"
                onClick={() => (window.location.href = "/privacy")}
              >
                Privacy Policy
              </b>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
